export default __webpack_public_path__ + "static/djmanager-logo-white-e76c5bceaae41614b13ed6775b0abb5d.png";